export default __webpack_public_path__ + "static/media/blogcard5.6e87e85e.png";